import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Store} from '@ngxs/store';
import {OrgsState} from '../+state/orgs/state';

export const orgInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip adding X-Org-Id header for OAuth/Keycloak requests to avoid CORS issues
  if (req.url.includes('/protocol/openid-connect/') || req.url.includes('keycloak')) {
    return next(req);
  }

  const orgId = inject(Store).selectSnapshot(OrgsState.selectedOrg);
  if (!orgId) {
    return next(req);
  }
  const reqClone = req.clone({
    headers: req.headers.set('X-Org-Id', orgId)
  });

  return next(reqClone);
};
